module.exports = __webpack_public_path__ + "assets/user-list.649ab6fa.svg";